module.exports = __webpack_public_path__ + "static/media/client-logo-8.b96fb8dc.jpg";